import { Row, Col, Form, Input, Space } from "antd";

import { AttachFile, DatePicker } from "../../../../../../../components";
import { Moment } from "moment";
import { useState } from "react";
import { AiOutlineCloudUpload } from "react-icons/ai";

const { RangePicker } = DatePicker;

export const ApplicationForLeaveNoSalaryForm = () => {
  const [startDate, setStartDate] = useState<Moment | null>(null);
  const handleRangeChange = (dates: any) => {
    if (dates) {
      setStartDate(dates[0]);
      return;
    }
    setStartDate(null);
  };

  const disabledDate = (current: any) => {
    if (!startDate) return false;
    const endDate = startDate.clone().add(2, "month").endOf("day");
    return current && (current < startDate || current > endDate);
  };

  return (
    <Row gutter={[16, 0]}>
      <Col span={24}>
        <Form.Item name="eFileContent">
          <AttachFile>
            <Space style={{ fontSize: 15 }}>
              Chứng từ đính kèm
              <AiOutlineCloudUpload size={24} />
              (word, excel, pdf, jpg,...)
            </Space>
          </AttachFile>
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian nghỉ phép"
          name="eVacationPeriod"
          rules={[
            {
              required: true,
              message: "Vui lòng chọn trường này!",
            },
          ]}
        >
          <RangePicker
            className="min-w-full"
            disabledDate={disabledDate}
            onCalendarChange={handleRangeChange}
          />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Địa chỉ thường trú"
          name="eAddress"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập trường này!",
            },
          ]}
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item
          label="Thời gian công tác tại cơ quan, chi nhánh"
          name="eBusinessTime"
        >
          <Input />
        </Form.Item>
      </Col>
      <Col span={12} xs={24} md={12}>
        <Form.Item label="Số lượng vật tư trả lại" name="eAssetReturnNum">
          <Input />
        </Form.Item>
      </Col>
      <Col span={24}>
        <Form.Item
          label="Lý do"
          name="eReason"
          rules={[
            {
              required: true,
              message: "Vui lòng nhập trường này!",
            },
          ]}
        >
          <Input.TextArea />
        </Form.Item>
      </Col>
    </Row>
  );
};
